
var cache = {};

/**
 * A resolver that caches rules and configuration as part of the bundle,
 * making them accessible in the browser.
 *
 * @param {Object} cache
 */
function Resolver() {}

Resolver.prototype.resolveRule = function(pkg, ruleName) {

  const rule = cache[pkg + '/' + ruleName];

  if (!rule) {
    throw new Error('cannot resolve rule <' + pkg + '/' + ruleName + '>');
  }

  return rule;
};

Resolver.prototype.resolveConfig = function(pkg, configName) {
  throw new Error(
    'cannot resolve config <' + configName + '> in <' + pkg +'>'
  );
};

var resolver = new Resolver();

var rules = {
  "conditional-flows": "error",
  "end-event-required": "error",
  "event-sub-process-typed-start-event": "error",
  "label-required": "error",
  "no-complex-gateway": "error",
  "no-disconnected": "error",
  "no-gateway-join-fork": "error",
  "no-implicit-split": "error",
  "single-event-definition": "error",
  "start-event-required": "error",
  "sub-process-blank-start-event": "error",
  "superfluous-gateway": "warning",
  "processmaker/custom-validation": "error",
  "processmaker/gateway-direction": "error",
  "processmaker/event-based-gateway": "error",
  "processmaker/call-activity-child-process": "error",
  "processmaker/id-required": "error",
  "processmaker/signal-ref-required": "error"
};

var config = {
  rules: rules
};

var bundle = {
  resolver: resolver,
  config: config
};

export { resolver, config };

export default bundle;



import rule_0 from 'bpmnlint/rules/conditional-flows';
cache['bpmnlint/conditional-flows'] = rule_0;

import rule_1 from 'bpmnlint/rules/end-event-required';
cache['bpmnlint/end-event-required'] = rule_1;

import rule_2 from 'bpmnlint/rules/event-sub-process-typed-start-event';
cache['bpmnlint/event-sub-process-typed-start-event'] = rule_2;

import rule_3 from 'bpmnlint/rules/label-required';
cache['bpmnlint/label-required'] = rule_3;

import rule_4 from 'bpmnlint/rules/no-complex-gateway';
cache['bpmnlint/no-complex-gateway'] = rule_4;

import rule_5 from 'bpmnlint/rules/no-disconnected';
cache['bpmnlint/no-disconnected'] = rule_5;

import rule_6 from 'bpmnlint/rules/no-gateway-join-fork';
cache['bpmnlint/no-gateway-join-fork'] = rule_6;

import rule_7 from 'bpmnlint/rules/no-implicit-split';
cache['bpmnlint/no-implicit-split'] = rule_7;

import rule_8 from 'bpmnlint/rules/single-event-definition';
cache['bpmnlint/single-event-definition'] = rule_8;

import rule_9 from 'bpmnlint/rules/start-event-required';
cache['bpmnlint/start-event-required'] = rule_9;

import rule_10 from 'bpmnlint/rules/sub-process-blank-start-event';
cache['bpmnlint/sub-process-blank-start-event'] = rule_10;

import rule_11 from 'bpmnlint/rules/superfluous-gateway';
cache['bpmnlint/superfluous-gateway'] = rule_11;

import rule_12 from 'bpmnlint-plugin-processmaker/rules/custom-validation';
cache['bpmnlint-plugin-processmaker/custom-validation'] = rule_12;

import rule_13 from 'bpmnlint-plugin-processmaker/rules/gateway-direction';
cache['bpmnlint-plugin-processmaker/gateway-direction'] = rule_13;

import rule_14 from 'bpmnlint-plugin-processmaker/rules/event-based-gateway';
cache['bpmnlint-plugin-processmaker/event-based-gateway'] = rule_14;

import rule_15 from 'bpmnlint-plugin-processmaker/rules/call-activity-child-process';
cache['bpmnlint-plugin-processmaker/call-activity-child-process'] = rule_15;

import rule_16 from 'bpmnlint-plugin-processmaker/rules/id-required';
cache['bpmnlint-plugin-processmaker/id-required'] = rule_16;

import rule_17 from 'bpmnlint-plugin-processmaker/rules/signal-ref-required';
cache['bpmnlint-plugin-processmaker/signal-ref-required'] = rule_17;